import { api } from "@/lib/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { conversionsKeys } from "./conversions.queries";

export const useDeleteConversion = () => {
  const queryClient = useQueryClient();
  return useMutation({
    async mutationFn({ id }: { id: string }) {
      const response = await api.delete(`/api/user/conversions/${id}`);

      return response.data;
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: conversionsKeys.all });
    },
  });
};
